import React from 'react';
import PropTypes from 'prop-types';

import NextAvailableButton from '../../times/containers/NextAvailableButton';
import Autoheight from '../../components/AutoHeight';
import DateTimePicker from '../../times/components/DateTimePicker';
import InvalidPromoError from '../../components/InvalidPromoError';

const PickTime = ({
  rescheduleAndAskPromo,
  rescheduleAndRemovePromo,
  setTime,
  setActiveDay,
  isTurnstileChallengeVisible,
  ...props
}) => (
  <div className="c-second-layer">
    <Autoheight>
      <DateTimePicker
        setTime={setTime}
        setActiveDay={setActiveDay}
        {...props}
      />
      <div className="layout layout--small layout--center layout--auto u-mt">
        { props.selectedTime &&
        <div className="layout__item">
          <button
            type="button"
            className="c-btn c-btn--primary u-pos-relative"
            onClick={rescheduleAndAskPromo}
          >
            Reschedule
            {
              isTurnstileChallengeVisible && (
                <div className="c-turnstile-modal" id="turnstile" />
              )
            }
          </button>
        </div>
        }
        { props.noTimesAvailable &&
        <div className="layout__item">
          <NextAvailableButton
            setTime={setTime}
            setActiveDay={setActiveDay}
          />
        </div>
        }
      </div>
    </Autoheight>
    <InvalidPromoError onConfirm={rescheduleAndRemovePromo} />
  </div>
);
PickTime.propTypes = {
  rescheduleAndAskPromo: PropTypes.func.isRequired,
  rescheduleAndRemovePromo: PropTypes.func.isRequired,
  selectedTime: PropTypes.string.isRequired,
  setTime: PropTypes.func.isRequired,
  setActiveDay: PropTypes.func.isRequired,
  noTimesAvailable: PropTypes.bool.isRequired,
  isTurnstileChallengeVisible: PropTypes.bool.isRequired,
};

export default PickTime;



// WEBPACK FOOTER //
// ./src/app/reservation/components/PickTime.jsx